import { Box, CircularProgress, Button } from '@material-ui/core';
import moment from 'moment';
import { useState, useMemo, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const NotificationList = ({
  notifications,
  onClickNotification,
  handleLoadMoreNotification
}) => {
  const [page, setPage] = useState(1);
  const [viewAll, setViewAll] = useState(true);
  const scrollRef = useRef(null);

  const numUnreadNotifications = useSelector(
    state => state.notificationSlice.numUnreadNotifications
  );
  const totalNotification = useSelector(
    state => state.notificationSlice.totalNotification
  );
  const isLoading = useSelector(state => state.notificationSlice.isLoading);
  const isEndList =
    (notifications || [])?.length >= totalNotification;

  const filteredNotifications = useMemo(() => {
    return viewAll
      ? notifications
      : (notifications || []).filter(item => !item.is_read);
  }, [notifications, viewAll]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50 && !isLoading && !isEndList && viewAll) {
      handleLoadMore();
    }
  };

  const handleLoadMore = () => {
    const countNext = page + 1;
    setPage(countNext);
    handleLoadMoreNotification(countNext);
  };


  useEffect(() => {
    if (notifications?.length <= 15) {
      setPage(1);
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }
  }, [notifications]);

  return (
    <Box
      ref={scrollRef}
      onScroll={handleScroll}
      style={{
        overflow: 'auto',
        flex: 1,
        backgroundColor: '#ffffff'
      }}
    >
      <Box display={'flex'} alignItems="center" p={1}>
        <Button
          size="small"
          style={{ fontWeight: 500, color: viewAll ? '#D9042F' : '#8B8C9B' }}
          onClick={() => setViewAll(true)}
        >
          Tất cả
        </Button>
        <Button
          size="small"
          style={{ fontWeight: 500, color: !viewAll ? '#D9042F' : '#8B8C9B' }}
          onClick={() => setViewAll(false)}
        >{`Chưa đọc (${numUnreadNotifications || 0})`}</Button>
      </Box>
      {filteredNotifications && filteredNotifications.length > 0 ? (
        filteredNotifications.map((entry, index) => {
          return (
            <Box
              key={entry._id ?? `${index}-${entry.created_at}`}
              onClick={() => onClickNotification(entry)}
              style={{
                padding: ' 10px 30px 0 4px',
                display: 'flex',
                flexDirection: 'row',
                justifyItems: 'center',
                backgroundColor: entry.is_read
                  ? 'rgb(255, 255, 255)'
                  : 'rgba(255, 145, 145, 0.25)',
                cursor: 'pointer'
              }}
            >
              <Box
                style={{
                  width: '30px',
                  padding: '0 25px',
                  display: 'flex',
                  position: 'relative',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  alt=""
                  style={{ width: 56 }}
                  src={`/static/iconNoti/notiIcon.svg`}
                />
              </Box>
              <Box style={{ flex: 1, minWidth: 0, color: '#03294a' }}>
                <Box
                  style={{
                    fontStyle: 'normal',
                    fontWeight: entry.is_read ? 500 : 'bold',
                    fontSize: '14px',
                    lineHeight: '20px',
                    alignItems: 'center',
                    textAlign: 'justify'
                  }}
                >
                  {entry.message}
                </Box>
                <Box
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '12px',
                    lineHeight: '14px',
                    color: '#828282',
                    padding: '10px 0'
                  }}
                >
                  {moment(entry.created_at).format('HH:mm:ss DD-MM-yyyy')}
                </Box>
              </Box>
            </Box>
          );
        })
      ) : (
        <Box
          style={{
            padding: ' 10px 30px 0 4px',
            cursor: 'pointer',
            color: '#03294a'
          }}
        >
          <Box style={{ textAlign: 'center', padding: '10px 0 24px' }}>
            Danh sách thông báo trống
          </Box>
        </Box>
      )}

      {isLoading && (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress size={24} color="secondary" />
        </Box>
      )}
    </Box>
  );
};


